<div class="relative w-full max-w-6xl mx-auto px-4 py-8">
      <!-- Header -->
      <div class="text-center mb-8">
        <h2 class="text-3xl font-bold bg-gradient-to-r from-red-600 to-pink-600 bg-clip-text text-transparent mb-2">
          Featured Videos
        </h2>
        <p class="text-gray-600 dark:text-gray-400">
          Discover our latest content
        </p>
      </div>

      <!-- Carousel Container -->
      <div class="relative overflow-hidden rounded-2xl">
        <!-- Main Carousel -->
        <div 
          #carousel
          class="flex transition-transform duration-500 ease-out"
          [style.transform]="'translateX(-' + (currentIndex * slideWidth) + '%)'">
          
          <div 
            *ngFor="let video of videos; let i = index"
            class="flex-shrink-0 px-2"
            [style.width.%]="slideWidth">
            
            <!-- Video Card -->
            <div 
              class="group relative bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer overflow-hidden"
              (click)="openVideo(video)">
              
              <!-- Thumbnail Container -->
              <div class="relative aspect-[9/16] overflow-hidden rounded-t-xl">
                <!-- Thumbnail Image -->
                <img 
                  [src]="video.thumbnail" 
                  [alt]="video.title"
                  class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  loading="lazy">
                
                <!-- Gradient Overlay -->
                <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <!-- Play Button -->
                <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div class="bg-red-600 rounded-full p-4 shadow-lg transform scale-90 group-hover:scale-100 transition-transform duration-300">
                    <svg class="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                  </div>
                </div>
                
                <!-- Duration Badge -->
                <div *ngIf="video.duration" 
                     class="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-2 py-1 rounded-lg">
                  {{ video.duration }}
                </div>
              </div>
              
              <!-- Video Info -->
              <div class="p-4">
                <h3 class="font-semibold text-gray-900 dark:text-white text-sm line-clamp-2 mb-2">
                  {{ video.title }}
                </h3>
                <div class="flex items-center text-xs text-gray-500 dark:text-gray-400">
                  <svg class="w-4 h-4 mr-1 text-red-600" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                  YouTube
                </div>
              </div>
              
              <!-- Hover Animation Lines -->
              <div class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                <div class="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-red-600 to-pink-600 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                <div class="absolute bottom-0 right-0 w-full h-0.5 bg-gradient-to-l from-red-600 to-pink-600 transform translate-x-full group-hover:translate-x-0 transition-transform duration-500 delay-100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Arrows -->
      <button 
        *ngIf="canGoPrev()"
        (click)="prevSlide()"
        class="absolute left-0 top-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 shadow-lg rounded-full p-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 z-10 group">
        <svg class="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-red-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </button>

      <button 
        *ngIf="canGoNext()"
        (click)="nextSlide()"
        class="absolute right-0 top-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 shadow-lg rounded-full p-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 z-10 group">
        <svg class="w-5 h-5 text-gray-600 dark:text-gray-300 group-hover:text-red-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </button>

      <!-- Indicators -->
      <div class="flex justify-center mt-6 space-x-2">
        <button
          *ngFor="let _ of getIndicators(); let i = index"
          (click)="goToSlide(i)"
          class="w-2 h-2 rounded-full transition-all duration-300"
          [class]="i === getIndex ? 'bg-red-600 w-6' : 'bg-gray-300 dark:bg-gray-600 hover:bg-red-400'">
        </button>
      </div>
    </div>

    <!-- Video Modal -->
    <div 
      *ngIf="selectedVideo"
      class="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      (click)="closeVideo()"
      (keydown.escape)="closeVideo()">
      
      <div class="relative bg-white dark:bg-gray-900 rounded-2xl overflow-hidden max-w-4xl w-full max-h-[90vh] shadow-2xl animate-in fade-in duration-300"
           (click)="$event.stopPropagation()">
        
        <!-- Close Button -->
        <button 
          (click)="closeVideo()"
          class="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
          aria-label="Close video">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>

        <!-- Video Embed -->
        <div class="aspect-video">
          <iframe
            [src]="getEmbedUrl(selectedVideo.url)"
            class="w-full h-full"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
            referrerpolicy="strict-origin-when-cross-origin">
          </iframe>
        </div>

        <!-- Video Info -->
        <div class="p-6">
          <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
            {{ selectedVideo.title }}
          </h3>
          <div class="flex items-center text-gray-600 dark:text-gray-400">
            <svg class="w-5 h-5 mr-2 text-red-600" fill="currentColor" viewBox="0 0 24 24">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
            Watch on YouTube
          </div>
        </div>
      </div>
    </div>